import { createInteriorRoomCalculator } from "./interior-room-shared.js";

/**
 * Living Room (Phase 13A). See interior-room-shared.ts for the shared
 * mechanism this config drives. Living room's distinguishing scope beyond
 * the shared flooring/painting/trim/lighting/built-ins/windows-doors set
 * is an optional fireplace - a common living room addition with real
 * cost impact that no other Phase 13A type in this batch prices.
 */
export const calculateLivingRoom = createInteriorRoomCalculator({
  projectType: "living_room",
  anchorItemId: "living_room_base_renovation",
  tierFeatures: [
    {
      answerKey: "living_room_flooring_type",
      itemIdByTier: { not_changing: null, basic: "living_room_flooring_basic", mid_range: "living_room_flooring_mid", premium: "living_room_flooring_premium" },
      quantityFromSqft: true,
      excludedMessage: "Flooring is not changing - excluded from this estimate."
    },
    {
      answerKey: "living_room_painting",
      itemIdByTier: { not_included: null, walls_only: "living_room_painting_walls", full_room: "living_room_painting_full" },
      quantityFromSqft: true,
      excludedMessage: "Painting was not included - excluded from this estimate."
    },
    {
      answerKey: "living_room_trim",
      itemIdByTier: { keep_existing: null, standard_upgrade: "living_room_trim_standard", premium_millwork: "living_room_trim_premium" },
      excludedMessage: "Trim/millwork is not being upgraded - excluded from this estimate."
    },
    {
      answerKey: "living_room_lighting",
      itemIdByTier: { keep_existing: null, standard_swap: "living_room_lighting_standard", statement_lighting: "living_room_lighting_statement" },
      excludedMessage: "Lighting is not being upgraded - excluded from this estimate."
    },
    {
      answerKey: "living_room_built_ins",
      itemIdByTier: { none: null, standard: "living_room_built_ins_standard", custom: "living_room_built_ins_custom" },
      excludedMessage: "No built-in shelving/entertainment cabinetry was requested - excluded from this estimate."
    },
    {
      answerKey: "living_room_windows_doors",
      itemIdByTier: { none: null, replace_existing: "living_room_windows_doors_replace", add_new: "living_room_windows_doors_add" },
      excludedMessage: "No window or door changes were requested - excluded from this estimate."
    }
  ],
  booleanFeatures: [
    { answerKey: "living_room_fireplace", itemId: "living_room_fireplace", excludedMessage: "A fireplace was not requested - excluded from this estimate." }
  ],
  electricalItemId: "living_room_electrical",
  demolitionItemId: "living_room_demolition",
  accessibilityItemId: "living_room_accessibility",
  permitDesignItemId: "living_room_permit_design"
});
